import ShippingNames from './shippingNames';

export default ShippingNames;